import { Link } from "react-router";
import { Mail } from "lucide-react";

// const socialLinks = [
//   { label: "Facebook", badge: "f", href: "https://facebook.com" },
//   { label: "Twitter", badge: "x", href: "https://twitter.com" },
//   { label: "Instagram", badge: "ig", href: "https://instagram.com" },
//   { label: "LinkedIn", badge: "in", href: "https://linkedin.com" },
// ];

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="text-xl mb-4">Immerse Foundation</h3>
            <p className="text-sm text-primary-foreground/80 leading-relaxed">   
Supporting verified grassroots initiatives with complete transparency that create livelihoods, expand education, and strengthen rural communities in Himachal.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  Projects
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/reports"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  Annual Reports
                </Link>
              </li> */}
              <li>
                <Link
                  to="/blog"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  News 
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="mb-4">Get Involved</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/get-involved"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  Contribute
                </Link>
              </li>
              <li>
                <Link
                  to="/apply"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  Apply for Funding
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/get-involved"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  Volunteer
                </Link>
              </li>
              <li>
                <Link
                  to="/get-involved"
                  className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  CSR Partnership
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact & Social */}
         <div>
            <h4 className="mb-4 text-center">Connect With Us</h4>
            <p className="text-sm text-primary-foreground text-center mb-4">hello@immerse.foundation</p>
            <div className="flex justify-center gap-6 mb-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center h-12 w-12 rounded-full border border-primary-foreground/20 text-primary-foreground/80 transition-colors hover:border-primary-foreground hover:text-primary-foreground"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true">
                  <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.03-1.84-3.03-1.85 0-2.13 1.44-2.13 2.93v5.67H9.38V9h3.41v1.56h.05c.48-.9 1.66-1.84 3.42-1.84 3.66 0 4.34 2.41 4.34 5.54v6.19ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z" />
                </svg>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center h-12 w-12 rounded-full border border-primary-foreground/20 text-primary-foreground/80 transition-colors hover:border-primary-foreground hover:text-primary-foreground"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true">
                  <path d="M7.75 2h8.5C19.3 2 22 4.7 22 8.25v7.5C22 19.3 19.3 22 16.25 22h-8.5C4.7 22 2 19.3 2 16.25v-7.5C2 4.7 4.7 2 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5ZM12 6.75A5.25 5.25 0 1 1 6.75 12 5.26 5.26 0 0 1 12 6.75Zm0 1.5A3.75 3.75 0 1 0 15.75 12 3.75 3.75 0 0 0 12 8.25Zm5.63-2.13a1.12 1.12 0 1 1-1.12-1.12 1.12 1.12 0 0 1 1.12 1.12Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-sm text-primary-foreground/60">
          <p className="max-w-xl leading-relaxed">
            Immerse Foundation (Regd number 50/2026)<br />
            House number 44, Ward 6, Gandhi Nagar, Hamirpur, Himachal Pradesh 177001
          </p>

          <div className="flex flex-col items-start md:items-end gap-3">
            <div className="flex gap-6">
              <a
                href="/privacy"
                className="hover:text-primary-foreground transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="/terms"
                className="hover:text-primary-foreground transition-colors"
              >
                Terms of Service
              </a>
            </div>

            <p>© {currentYear} Immerse Foundation. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
